import { Component, inject } from '@angular/core';
import { ClosetDoorsStandardService } from 'src/app/services/configurators-2d/applications/closet-doors-standard.service';
import { CurrentService } from 'src/app/services/current.service';
import { DoorOffsetCalculatorService } from '../door-offset-calculator.service';

/**
 * Preview de l'étape Gamme.
 * Affiche les vantaux réels (calques API) si la configuration est chargée,
 * sinon des silhouettes neutres en attente de sélection.
 */
@Component({
  selector: 'ng-casto-closet-doors-standard-preview-range',
  templateUrl: './preview-step-range.component.html',
  styleUrls: ['./preview-step-range.component.scss'],
})
export class PreviewStepRangeComponent {
  private readonly current = inject(CurrentService);
  private readonly closetDoorsService = inject(ClosetDoorsStandardService);
  private readonly doorOffsetCalculator = inject(DoorOffsetCalculatorService);

  /** Préfixe d'URL pour les images servies par l'API. */
  protected readonly baseImgURL = this.closetDoorsService.apiUrl;

  /** Liste des vantaux configurés. Vide tant que la gamme n'a pas été appliquée. */
  protected get doors() {
    return this.current.closetDoors.doors;
  }

  /** Nombre de vantaux sélectionné — utilisé pour les silhouettes de substitution. */
  protected get doorNumber() {
    return this.current.closetDoors.doorNumber;
  }

  /** Indique si le vantail est en premier plan (recouvrement coulissant). */
  protected isInFront(id: number): boolean {
    const panel = this.getCurrentPanel(id);
    return panel !== null ? panel.orderFromFront === 1 : false;
  }

  /** Indique si le vantail a un décalage horizontal de recouvrement. */
  protected isOffset(id: number): boolean {
    const panel = this.getCurrentPanel(id);
    return panel !== null ? panel.isOffset : false;
  }

  /**
   * Retourne la valeur CSS `margin-left` pour le recouvrement coulissant.
   */
  protected calculateOffset(id: number, doorHtmlElement: HTMLElement): string {
    const door = this.doors.find(d => d.id === id);
    return `calc(-${this.doorOffsetCalculator.calculateOffset(door, this.doorNumber, doorHtmlElement)}px)`;
  }

  private getCurrentPanel(id: number): any {
    const allPanels = this.closetDoorsService.panelGroups.flatMap(g => g.panels);
    const panel = allPanels.find(p => p.panelCount === this.doorNumber);
    return panel?.panels?.find(p => p.index === id) ?? null;
  }
}
